// GetPageMetaData returns metadata of a page, e.g. for SEO purposes.
export const CustomPagesMetaService_GetPageMetaDataLazy = () =>
  import("./service.grpc").then(
    (m) => m.CustomPagesMetaService_GetPageMetaData
  );
CustomPagesMetaService_GetPageMetaDataLazy.method =
  "aysa_api.services.custom_pages.v1.meta.CustomPagesMetaService/GetPageMetaData" as const;
